import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NumberToPercentPipe } from './pipes/number-to-percent.pipe';
import { ServerDatetimeToDisplayDatetimePipe } from './pipes/server-datetime-to-display-datetime.pipe';
import { ServerDatetimeToDisplayMonthPipe } from './pipes/server-datetime-to-display-month.pipe';
import { ServerDatetimeToDisplayDatePipe } from './pipes/server-datetime-to-display-date.pipe';
import { FullTextSearchPipe } from './pipes/full-text-search.pipe';
import { MoneyFormatPipe } from './pipes/money-format.pipe';
import { SortListObjectByKeyPipe } from './pipes/sort-list-objects-by-key.pipe';
import { IdToKeyConfigPipe } from './pipes/id-to-key-config.pipe';
import { FormatAllDateTimePipe } from './pipes/format-all-date-time.pipe';
import { DateSplitterPipe } from './pipes/date-splitter.pipe';
import { PreviewImageDirective } from './directives/preview-image.directive';
import { SetBase64ToModelDirective } from './directives/set-base64-to-model.directive';
import { MinValidationDirective } from './directives/min-validation.directive';
import { MaxValidationDirective } from './directives/max-validation.directive';
import { DatePickerDirective } from './directives/date-picker/date-picker.directive';
import { MoneyFormatDirective } from './directives/money-format.directive';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ngBootstrapDateFormatterFactory } from './factories/ng-bootstrap-date-formatter.factory';
import { RouterModule } from '@angular/router';

import { ConfirmPopupService } from './services/confirm-popup/confirm-popup.service';
import { PopupService } from './services/popup/popup.service';
import { ConfirmPopupComponent } from './services/confirm-popup/confirm-popup.component';

import {
    // WebAppSharedLibsModule,
    WebAppSharedCommonModule,
    CSRFService,
    AuthServerProvider,
    AccountService,
    UserService,
    StateStorageService,
    // LoginService,
    Principal,
    HasAnyAuthorityDirective,
    UserRouteAccessCrudService
} from './';
import { SystemSettingStorageService } from './utils/system-setting-storage.service';
import { FormatNumberInputProvider } from './components/format-number-input/format-number-input.component';
import { PermissionService } from './utils/permissions.service';
import { CompanyService } from './services/company/company.service';
import { TemplateType } from './utils/template-type';
import { SaveAuditService } from './utils/save-audit.service';
import { Common } from './common/common';

@NgModule({
    imports: [
        RouterModule,
        // WebAppSharedLibsModule,
        WebAppSharedCommonModule,
    ],
    declarations: [
        HasAnyAuthorityDirective,
        NumberToPercentPipe,
        ServerDatetimeToDisplayDatetimePipe,
        ServerDatetimeToDisplayMonthPipe,
        ServerDatetimeToDisplayDatePipe,
        FullTextSearchPipe,
        MoneyFormatPipe,
        SortListObjectByKeyPipe,
        IdToKeyConfigPipe,
        FormatAllDateTimePipe,
        DateSplitterPipe,
        PreviewImageDirective,
        SetBase64ToModelDirective,
        MinValidationDirective,
        MaxValidationDirective,
        DatePickerDirective,
        MoneyFormatDirective,

        // WebAppSharedLibsModule,
        ConfirmPopupComponent,
    ],
    providers: [
        // LoginService,
        AccountService,
        StateStorageService,
        Principal,
        CSRFService,
        AuthServerProvider,
        UserService,
        {
            provide: NgbDateParserFormatter,
            useFactory: ngBootstrapDateFormatterFactory
        },

        ConfirmPopupService,
        PopupService,
        UserRouteAccessCrudService,
        MoneyFormatPipe,
        SystemSettingStorageService,
        FormatNumberInputProvider,
        PermissionService,
        CompanyService,
        TemplateType,
        SaveAuditService,
        Common,
    ],
    entryComponents: [
        ConfirmPopupComponent,
    ],
    exports: [
        RouterModule,
        WebAppSharedCommonModule,
        HasAnyAuthorityDirective,

        NumberToPercentPipe,
        ServerDatetimeToDisplayDatetimePipe,
        ServerDatetimeToDisplayMonthPipe,
        ServerDatetimeToDisplayDatePipe,
        FullTextSearchPipe,
        MoneyFormatPipe,
        SortListObjectByKeyPipe,
        IdToKeyConfigPipe,
        FormatAllDateTimePipe,
        DateSplitterPipe,
        ConfirmPopupComponent,
        PreviewImageDirective,
        SetBase64ToModelDirective,
        MinValidationDirective,
        MaxValidationDirective,
        DatePickerDirective,
        MoneyFormatDirective
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class WebAppSharedModule {}
